var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCat4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#E7AF65"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1215 23.9927L39.3118 19.5774C39.3906 19.2849 39.1719 19 38.8718 19H22.0192C21.7191 19 21.5004 19.2849 21.5792 19.5748L22.7695 23.9902H38.1215V23.9927Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3472 23.7893H21.5434C20.142 23.7893 19 24.9313 19 26.3327C19 27.7341 20.142 28.8761 21.5434 28.8761C22.0063 28.8761 22.4412 28.7489 22.8151 28.5327V40.8301H26.3759V31.6738C26.3759 31.1118 26.8311 30.6565 27.3932 30.6565C27.9553 30.6565 28.4106 31.1118 28.4106 31.6738V40.8301H32.48V31.6738C32.48 31.1118 32.9353 30.6565 33.4974 30.6565C34.0595 30.6565 34.5147 31.1118 34.5147 31.6738V40.8301H38.0755V28.5327C38.4494 28.7489 38.8843 28.8761 39.3472 28.8761C40.7486 28.8761 41.8906 27.7341 41.8906 26.3327C41.8906 24.9313 40.7486 23.7893 39.3472 23.7893Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat4);
export default __webpack_public_path__ + "static/media/cat_4.eaab8a3781be6d779cda5266b810c41f.svg";
export { ForwardRef as ReactComponent };